import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetCaseListPagingAndFilterRequest } from '../models/request/case/GetCaseListPagingAndFilterRequest';

export class CaseService {
    static async getCaseList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getCaseList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Case/getCaseList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCaseList(inputObj: GetCaseListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCaseList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Case/exportCaseList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCaseListPagingAndFilter(inputObj: GetCaseListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCaseListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Case/GetCaseListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addCase(_caseId: string | undefined, _name: string | undefined, _openingBalance: string | undefined, _currencyTypeId: string | undefined, _accountingCode: string | undefined, _openingBalanceDate: string | undefined, _isCustomActive: number) {
        try {

            var inputObj = {
                caseId: _caseId,
                name: _name,
                openingBalance: _openingBalance,
                currencyTypeId: _currencyTypeId,
                accountingCode: _accountingCode,
                openingBalanceDate: _openingBalanceDate,
                isCustomActive: _isCustomActive,
            }

            console.log('SERVICE CALL - AddCase', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Case/AddCase', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCase(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCase', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Case/deleteCase', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCaseById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCaseById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Case/getCaseById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}